import anime from 'animejs';
import _every from 'lodash/every';
import _isEmpty from 'lodash/isEmpty';
import Mousetrap from 'mousetrap';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  createNewFolderHide,
  createNewFolderShow,
  createNewFolderUpdateName,
  updateFolderToMoveTo,
  updateShowMoveModal,
} from 'actions/videosDashboard';
import { KEY_ENTER, KEY_ESCAPE } from 'constants/keyCodes';
import { ESCAPE } from 'constants/mousetrap';
import { FOLDER, VIDEO } from 'constants/videosDashboard';
import { createFolderCreator } from 'creators/shareVideo';
import {
  bulkMoveFoldersVideosCreator,
  updatePastForMove,
} from 'creators/videosDashboard';

import Button from 'components/ui-components/button';
import Transition from 'components/ui-components/transition';
import HierarchyGrid from 'components/videos-dashboard/hierarchy-grid';

import './styles.less';

const CONTAINER_CLASS = 'move-modal-container';

const SHOW_MODAL_CLASS = 'show-move-modal';

class MoveModal extends Component {
  focusNewFolderInput = null;
  hierarchyGridRef = null;
  newFolderInputRef = null;
  initialHierarchyGridTop = null;

  render() {
    const {
      checkedItems,
      currentFolderId,
      folderToMoveTo,
      show,
      showNewFolderInput,
      newFolderName,
      isFetchingHierarchy,
    } = this.props;

    if (!show) {
      return null;
    }

    let moveButtonDisabled = true;
    let name = null;

    if (checkedItems.length === 1) {
      name = checkedItems[0].name;
    } else if (_every(checkedItems, item => item.type === FOLDER)) {
      name = `${checkedItems.length} Folders`;
    } else if (_every(checkedItems, item => item.type === VIDEO)) {
      name = `${checkedItems.length} Videos`;
    } else {
      name = `${checkedItems.length} Items`;
    }

    if (
      !_isEmpty(folderToMoveTo) &&
      folderToMoveTo.id !== currentFolderId &&
      folderToMoveTo.id != null
    ) {
      moveButtonDisabled = false;
    }

    const folderName =
      (showNewFolderInput ? newFolderName : folderToMoveTo.name) || '...';

    return (
      <div className={CONTAINER_CLASS} onClick={this.exit}>
        <div className="move-modal">
          <div className="title">
            Move <h4 className="name">{name}</h4> to{' '}
            <h4 className="name">{folderName}</h4>
          </div>
          <div className="grid">
            <Transition
              alwaysRender={true}
              show={this.props.showNewFolderInput}
              onDidMount={() => this.playAnimation('showNewFolderName')}
              onWillUnmount={() => this.playAnimation('hideNewFolderName')}
            >
              <div className="move-new-folder-input-wrap">
                <input
                  type="text"
                  className="move-new-folder-input"
                  ref={this.refInputFolderName}
                  value={this.props.newFolderName}
                  onChange={this.onChangeNewFolderName}
                  onFocus={this.props.onFocusNewFolderName}
                  onBlur={this.props.onBlurNewFolderName}
                  onKeyUp={this.onKeyUpNewFolderName}
                />
              </div>
            </Transition>
            <div
              className="hierarchy-grid-wrap"
              ref={this.saveHierarychyGridRef}
            >
              <HierarchyGrid />
            </div>
          </div>
          <div
            className={`move-new-folder-button ${
              isFetchingHierarchy ? 'disabled' : ''
            }`}
            onClick={this.onClickNewFolder}
          >
            + Create New Folder
          </div>
          <div className="controls">
            <Button
              buttonClass="move-cancel-button"
              buttonType="rp-secondary-3"
              value="Cancel"
              onClicked={this.props.onClickCancel}
            />
            <Button
              buttonClass="move-confirm-button"
              buttonType="rp-primary-3"
              disabled={moveButtonDisabled}
              value="Move"
              onClicked={this.move}
            />
          </div>
        </div>
      </div>
    );
  }

  UNSAFE_componentWillMount() {
    this._toggleShow(this.props.show);
  }

  componentWillUnmount() {
    this._toggleShow(this.props.show);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.show != nextProps.show) {
      this._toggleShow(nextProps.show);
    }

    if (!this.props.showNewFolderInput && nextProps.showNewFolderInput) {
      this.focusNewFolderInput = true;
    }
  }

  saveHierarychyGridRef = ref => {
    this.hierarchyGridRef = ref;

    if (ref) {
      // Save top position for later use in animation
      this.initialHierarchyGridTop = window.getComputedStyle(ref).top;
    }
  };

  playAnimation = name => {
    if (!this.newFolderInputRef) {
      return;
    }

    const elasticity = 200;

    if (name == 'showNewFolderName') {
      anime({
        targets: this.hierarchyGridRef,
        top: 0,
        elasticity,
      });

      return anime({
        targets: this.newFolderInputRef.parentNode,
        scaleY: [0, 1],
        opacity: [0, 1],
        elasticity,
      });
    }

    if (name == 'hideNewFolderName') {
      anime({
        targets: this.hierarchyGridRef,
        top: this.initialHierarchyGridTop,
        elasticity,
      });

      return anime({
        targets: this.newFolderInputRef.parentNode,
        scaleY: [1, 0],
        opacity: [1, 0],
        elasticity,
      });
    }
  };

  onClickNewFolder = () => {
    if (this.newFolderInputRef) {
      this.newFolderInputRef.select();
      this.newFolderInputRef.closest('.grid').scrollTo(0, 0);
    }

    this.props.onClickNewFolder();
  };

  onKeyUpNewFolderName = event => {
    if (KEY_ENTER.indexOf(event.key) > -1) {
      this.props.onEnteredNewFolderName(this.props.newFolderName);
    }

    if (KEY_ESCAPE.indexOf(event.key) > -1) {
      this.props.onCancelNewFolder();
    }
  };

  onChangeNewFolderName = event => {
    this.props.onChangeNewFolderName(event.target.value);
  };

  refInputFolderName = ref => {
    this.newFolderInputRef = ref;

    if (this.focusNewFolderInput && ref) {
      this.focusNewFolderInput = false;
      ref.select();
      ref.closest('.grid').scrollTo(0, 0);
    }
  };

  _toggleShow(show) {
    // control body scrolling
    if (show) {
      document.body.classList.add(SHOW_MODAL_CLASS);
    } else {
      document.body.classList.remove(SHOW_MODAL_CLASS);
    }

    if (show) {
      Mousetrap.bind(ESCAPE, this.props.onHide);
    } else {
      Mousetrap.unbind(ESCAPE);
    }
  }

  exit = e => {
    if (e.target.className !== CONTAINER_CLASS) {
      return;
    }

    this.props.onHide();
  };

  move = () => {
    const { folderToMoveTo } = this.props;

    this.props.onMove(
      folderToMoveTo.special_id || folderToMoveTo.id,
      folderToMoveTo.name,
      this.props.checkedItems
    );
  };
}

const mapStateToProps = (state, passedProps) => {
  const {
    checked_items: checkedItems,
    folder_id: currentFolderId,
    folder_to_move_to: folderToMoveTo,
    show_move_modal: show,
    new_folder_name: newFolderName,
    show_new_folder_input: showNewFolderInput,
    is_fetching_hierarchy: isFetchingHierarchy,
  } = state.videos_dashboard;

  return {
    // Allow users of component to overwrite state with props
    currentFolderId: passedProps.currentFolderId || currentFolderId,
    showNewFolderInput,
    newFolderName,
    checkedItems,
    folderToMoveTo,
    show,
    isFetchingHierarchy,
  };
};

const mapDispatchToProps = (dispatch, passedProps) => ({
  onFocusNewFolderName: () => dispatch(updateFolderToMoveTo(null)),
  onBlurNewFolderName: () => dispatch(createNewFolderHide()),
  onChangeNewFolderName: name => dispatch(createNewFolderUpdateName(name)),
  onClickNewFolder: () => dispatch(createNewFolderShow()),
  onCancelNewFolder: () => dispatch(createNewFolderHide()),
  onEnteredNewFolderName: name => {
    dispatch(createFolderCreator(null, name));
  },
  onClickCancel: () => dispatch(updateShowMoveModal(false)),
  onHide: () => dispatch(updateShowMoveModal(false)),
  onMove:
    passedProps.onMove ||
    ((toFolderId, toFolderName, items) => {
      dispatch(updatePastForMove());
      dispatch(bulkMoveFoldersVideosCreator(null, toFolderId, items));
      dispatch(updateShowMoveModal(false));
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(MoveModal);
